/**
 * 系统管理 用户管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>优惠卷管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="场地名称:">
        <el-select v-model="formInline.station_id" placeholder="请选择部门名称" clearable>
          <el-option v-for="item in station_names" :label="item.station_name" :value="item.id" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input size="small" v-model="formInline.mobile" placeholder="输入手机号"></el-input>
      </el-form-item>
      <el-form-item label="车牌号">
        <el-input size="small" v-model="formInline.plate" placeholder="输入车牌号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-search" @click="showPlateStatus">查询入场/下发优惠卷</el-button>
      </el-form-item>
    </el-form>
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column sortable prop="id" label="序号" >
      </el-table-column>
      <el-table-column sortable prop="mobile" label="手机号" >
      </el-table-column>
      <el-table-column sortable prop="in_time" label="入场时间" >
      </el-table-column>
      <el-table-column sortable prop="plate" label="车牌" >
      </el-table-column>
      <el-table-column sortable prop="coupon_code" label="优惠卷ID" >
      </el-table-column>
      <el-table-column sortable prop="bus_id" label="校验码" >
      </el-table-column>
      <el-table-column sortable prop="timestamp" label="下发时间" >
      </el-table-column>
      <el-table-column sortable prop="status" label="下发状态" >
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog title="入场查询" :visible.sync="couponFormVisible" width="50%" @click="closeDialog">
      <el-form label-width="120px" :model="couponForm">
        <el-form-item label="场地名称:">
        <el-select v-model="couponForm.station_id" placeholder="请选择场地" clearable>
          <el-option v-for="item in station_names" :label="item.station_name" :value="item.id" :key="item.id"></el-option>
        </el-select>
      </el-form-item>
        <el-form-item label="车牌号码" prop="plate">
          <el-input size="small" v-model="couponForm.plate" auto-complete="off" placeholder="请输入车牌"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="getPlateStatus()">查询</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="sendCoupon()">发卷</el-button>
      </div>
    </el-dialog>
</div>
</template>

<script>
// 导入请求方法
import { getStationNames,listCoupon,getPlateStatus,sendCoupon } from '../../api/station'
import { getUser,updateAppUser } from '../../api/price'
import Pagination from '../../components/Pagination'
import { getBackendFeeLog,getAppUserCharge,getAppUserPlate} from '../../api/money'
export default {
  data() {
    return {
      couponFormVisible: false,
      title: '添加',
      // 请求数据参数
      formInline: {
        per_page: 10,
        limit: 10,
        mobile: '',
        station_id:'',
        plate:''
      },
      couponForm: {
        station_id:'',
        plate:''
      },
      tableInline: {
        per_page: 10,
        limit: 10,
        stock_user_id:0,
      },
      station_names:[],
      //用户数据
      listData: [],

      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      tablepageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    this.getStationNames()
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    closeDialog() {
      this.couponFormVisible  = false
    },
    showPlateStatus(){
      this.couponFormVisible = true
      this.couponForm={
        station_id:'',
        plate:''
      }
    },
    getPlateStatus(){
      getPlateStatus(this.couponForm).then(res => {
        if (res.code == 0) {
          if (res.data.return_code == 'SUCCESS'){
            this.$message({
              type: 'success',
              message: res.data.return_data
            })
          } else {
            this.$message({
              type: 'info',
              message: res.data.return_msg
            })
          }
        } else {
          this.$message.error(res.message)
          return false
        }
        console.log(res)
      })
    },
    sendCoupon(){
      sendCoupon(this.couponForm).then(res => {
        if (res.code == 0) {
          if (res.data.return_code == 'SUCCESS'){
            this.$message({
              type: 'success',
              message: res.data.return_data
            })
          } else {
            this.$message({
              type: 'info',
              message: res.data.return_msg
            })
          }
        } else {
          this.$message.error(res.message)
          return false
        }
        console.log(res)
      })
    },
    getStationNames(){
      getStationNames().then(res => {
        if (res.code == 0) {
            this.station_names = res.data
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },

    // 获取数据方法
        // 获取公司列表
    getdata() {
      this.loading = true
      listCoupon(this.formInline).then(res => {
        if (res.code == 0) {
          this.loading = false
          this.listData = res.data.data
          this.pageparm.currentPage = res.data.current_page
          this.pageparm.pageSize = res.data.per_page
          this.pageparm.total = res.data.total
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.editForm.id){
            updateAppUser(this.editForm.id,this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code ==0) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
          }
        } else {
          return false
        }
      })
    },





  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/system/Coupon.vue